import { Text as ChakraText, TextProps as ChakraTextProps, useStyleConfig } from '@chakra-ui/react';
import React, { FC } from 'react';

import { TextSizes } from '@application/theme';
import { TextVariants } from '@application/theme';

export interface TextProps extends ChakraTextProps {
  variant?: TextVariants;
  size?: TextSizes;
}

export const Text: FC<TextProps> = ({ children, variant, ...props }) => {
  const styles = useStyleConfig('Text', { variant });

  return (
    <ChakraText sx={styles} {...props}>
      {children}
    </ChakraText>
  );
};

Text.displayName = 'Text';
